<template>
  <div class="apply-step apply-step--terminal">
    <div class="apply-step__icon">🌱</div>
    <h2>Tu perfil es interesante</h2>
    <p>Por ahora algunos criterios no se ajustan al rol disponible.</p>
    <p>Guardamos tus datos y te contactaremos cuando haya una oportunidad que coincida contigo.</p>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ResultFuturo',
  mounted() { this.clearAll() },
  methods: { ...mapActions('apply', ['clearAll']) },
}
</script>

<style src="../apply-step.css" scoped></style>
<style scoped>
.apply-step--terminal { text-align: center; padding: 2rem 1rem; }
.apply-step__icon { font-size: 4rem; margin-bottom: 1rem; }
</style>
